const cents = value => Math.round((Number(value) || 0) * 100)

export function accountTypeAllows(code, isPartner) {
  const identifier = code?.account_type?.identifier
  if (identifier === 'pro') return Boolean(isPartner)
  if (identifier === 'individual') return !isPartner
  return true
}

export function cartPromoOffers({ codes, order, isPartner, limit = 3 }) {
  const products = cents(order?.total_variants_ttc)

  return (codes || [])
    .filter(code => code?.code && Number(code.value) > 0)
    .filter(code => accountTypeAllows(code, isPartner))
    .map(code => ({
      code,
      missing: Math.max(0, cents(code.minimum_order_value) - products) / 100,
    }))
    .sort((a, b) => Number(a.missing > 0) - Number(b.missing > 0))
    .slice(0, limit)
}

export function promoCodeError(error) {
  const response = error?.response
  if (!response) return { key: 'plugins.swalError.network' }
  if (response.status === 429) {
    return { key: 'plugins.swalError.tooManyRequests' }
  }

  const messages = response.data?.errors?.code
  const text = Array.isArray(messages) ? messages.join('\n').trim() : ''

  return text ? { text } : { key: 'components.cartPromoCodeForm.applyFailed' }
}
